import {
  Box,
  Button,
  IconButton,
  Modal,
  Slide,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ExamQuestionCard from "components/ExamQuestionCard";
import { ListQuestion } from "models/managerTest";
import React, { useMemo, useState } from "react";
import { isLimitedDisplay, pickDisplayedQuestions } from "utils/examPreview";

export interface ExamStudentPreviewModalProps {
  open: boolean;
  onClose: () => void;
  questions: ListQuestion[];
  displayCount?: number | null;
  examTitle?: string;
  isEssay?: boolean;
}

export default function ExamStudentPreviewModal({
  open,
  onClose,
  questions,
  displayCount,
  examTitle,
  isEssay,
}: ExamStudentPreviewModalProps) {
  const [shuffleKey, setShuffleKey] = useState(0);

  const previewQuestions = useMemo(
    () => pickDisplayedQuestions(questions, displayCount, shuffleKey),
    [questions, displayCount, shuffleKey]
  );

  const limited = isLimitedDisplay(displayCount ?? null, questions.length);

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Slide direction="up" in={open}>
        <Box
          style={{
            position: "relative",
            outline: "none",
            width: "92%",
            maxWidth: 900,
            maxHeight: "88vh",
            overflowY: "auto",
            backgroundColor: "#F8FAFC",
            borderRadius: 20,
            padding: "24px 28px 28px",
            boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.25)",
          }}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6" style={{ fontWeight: 800, color: "#0F172A" }}>
              Xem thử giao diện làm bài (Học viên)
            </Typography>
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          {examTitle && (
            <Typography variant="subtitle2" style={{ marginBottom: 12, fontWeight: 700, color: "#475569" }}>
              Đề thi: {examTitle}
            </Typography>
          )}

          <Box
            mb={3}
            p={2}
            style={{
              backgroundColor: limited ? "#EFF6FF" : "#FEF3C7",
              borderRadius: 12,
              border: `1px solid ${limited ? "#BFDBFE" : "#FDE68A"}`,
            }}
          >
            <Typography variant="body2" style={{ fontWeight: 600, color: limited ? "#1E40AF" : "#92400E" }}>
              {limited ? (
                <>
                  Hiển thị <strong>{previewQuestions.length}</strong> / {questions.length} câu (ngẫu nhiên). Mỗi học viên hoặc mỗi lần bấm &quot;Shuffle lại&quot; sẽ thấy bộ câu khác nhau.
                </>
              ) : (
                <>
                  Hiển thị <strong>tất cả {questions.length} câu</strong>. Nhập số câu ngẫu nhiên (nhỏ hơn tổng số câu) để xem thử chế độ giới hạn.
                </>
              )}
            </Typography>
            {limited && (
              <Box mt={1.5}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => setShuffleKey((k) => k + 1)}
                  style={{
                    borderRadius: 8,
                    fontWeight: 700,
                    fontSize: "0.78rem",
                    borderColor: "#2563EB",
                    color: "#2563EB",
                    backgroundColor: "#FFFFFF",
                    textTransform: "none",
                  }}
                >
                  Shuffle lại bộ câu hỏi
                </Button>
              </Box>
            )}
          </Box>

          {previewQuestions.map((item, index) => (
            <ExamQuestionCard
              key={`${item.id ?? index}-${shuffleKey}`}
              question={item}
              index={index}
              mode="view"
              isEssay={isEssay}
            />
          ))}

          <Box textAlign="right" mt={3}>
            <Button
              variant="contained"
              onClick={onClose}
              style={{
                backgroundColor: "#0F172A",
                color: "#FFFFFF",
                borderRadius: 10,
                fontWeight: 700,
                padding: "8px 24px",
                textTransform: "none",
              }}
            >
              Đóng xem thử
            </Button>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
}

